import {Season} from "./season";

export class Category {

    id?: string;
    name: string = '';
    fullPrice: number = 0;
    reducedPrice: number = 0;
    createdAt?: string;
    updatedAt?: string;
    companyId?: string;
    createdById?: string;
    parentId?: string;
    parent?: Category;
    seasonId?: string;
    season?: Season


    constructor(raw?: any) {
        if (raw) {
            if (raw.id || raw.id !== '') this.id = raw.id
            this.name = raw.name;
            this.fullPrice = parseFloat(raw.fullPrice);
            this.reducedPrice = parseFloat(raw.reducedPrice);
            this.createdAt = raw.createdAt;
            this.updatedAt = raw.updatedAt;
            this.companyId = raw.companyId;
            this.createdById = raw.createdById;
            this.parentId = raw.parentId;
            this.seasonId = raw.seasonId;
            if (this.season) this.season = new Season(raw.season);
            if (raw.parent && Object.keys((raw).parent).length > 0 ) this.parent = raw.parent;
        }
    }
}
